import { FullWidthBar } from 'components/core-v2/atoms'
import { Loading } from 'components/core-v2/pages'

import classes from './index.module.scss'

interface Props {
  isLoading?: boolean
  leftElement?: React.ReactNode
  mainElement?: React.ReactNode
  topBarElement?: React.ReactNode
}

export const LeftSideBar = ({
  isLoading = false,
  leftElement,
  mainElement,
  topBarElement
}: Props) => (
  <div className={classes.root}>
    <aside className={classes.leftSideWrapper}>{leftElement}</aside>
    <div className={classes.rightSideWrapper}>
      <FullWidthBar size="large">{topBarElement}</FullWidthBar>
      <div className={classes.mainElementWrapper}>{isLoading ? <Loading /> : mainElement}</div>
    </div>
  </div>
)
